import { ButtonV2 } from "../../../components/ButtonV2/ButtonV2"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../../components/Dialog/Dialog"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../../../components/Collapsible/Collapsible"
import { ChevronDown, Instagram, FileCode2, ShoppingCart } from "lucide-react"
import { useTranslation } from "react-i18next"

export const InstallInstructionsModal = () => {
  const { t } = useTranslation()

  return (
    <Dialog>
      <DialogTrigger asChild>
        <ButtonV2 variant="outline" size="sm" className="text-xs sm:text-sm break-words whitespace-normal text-center">
          {t("bookings.widget.help")}
        </ButtonV2>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("bookings.widget.install_instructions")}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <Collapsible>
            <CollapsibleTrigger className="flex w-full items-center justify-between rounded-lg border p-4 hover:bg-muted">
              <div className="flex items-center space-x-2">
                <Instagram className="h-5 w-5" />
                <span className="font-medium">Instagram</span>
              </div>
              <ChevronDown className="h-4 w-4" />
            </CollapsibleTrigger>
            <CollapsibleContent className="px-4 pt-2">
              <ol className="list-decimal list-inside space-y-2 text-sm">
                <li>{t("bookings.widget.instagram_step_1")}</li>
                <li>{t("bookings.widget.instagram_step_2")}</li>
                <li>{t("bookings.widget.instagram_step_3")}</li>
                <li>{t("bookings.widget.instagram_step_4")}</li>
                <li>{t("bookings.widget.instagram_step_5")}</li>
              </ol>
            </CollapsibleContent>
          </Collapsible>

          <Collapsible>
            <CollapsibleTrigger className="flex w-full items-center justify-between rounded-lg border p-4 hover:bg-muted">
              <div className="flex items-center space-x-2">
                <ShoppingCart className="h-5 w-5" />
                <span className="font-medium">Shoper</span>
              </div>
              <ChevronDown className="h-4 w-4" />
            </CollapsibleTrigger>
            <CollapsibleContent className="px-4 pt-2">
              <ol className="list-decimal list-inside space-y-2 text-sm">
                <li>{t("bookings.widget.shoper_step_1")}</li>
                <li>{t("bookings.widget.shoper_step_2")}</li>
                <li>{t("bookings.widget.shoper_step_3")}</li>
                <li>{t("bookings.widget.shoper_step_4")}</li>
                <li>{t("bookings.widget.shoper_step_5")}</li>
              </ol>
            </CollapsibleContent>
          </Collapsible>

          <Collapsible>
            <CollapsibleTrigger className="flex w-full items-center justify-between rounded-lg border p-4 hover:bg-muted">
              <div className="flex items-center space-x-2">
                <FileCode2 className="h-5 w-5" />
                <span className="font-medium">WordPress</span>
              </div>
              <ChevronDown className="h-4 w-4" />
            </CollapsibleTrigger>
            <CollapsibleContent className="px-4 pt-2">
              <ol className="list-decimal list-inside space-y-2 text-sm">
                <li>{t("bookings.widget.wordpress_step_1")}</li>
                <li>{t("bookings.widget.wordpress_step_2")}</li>
                <li>{t("bookings.widget.wordpress_step_3")}</li>
                <li>{t("bookings.widget.wordpress_step_4")}</li>
                <li>{t("bookings.widget.wordpress_step_5")}</li>
              </ol>
            </CollapsibleContent>
          </Collapsible>
        </div>
      </DialogContent>
    </Dialog>
  )
}

